<div class="avatar-box">
	<div class="word-avatar" style.background-color="#{{notification.sender?.bgColor}}">
		<div class="short-name">
			{{notification.sender?.shortCode}}
		</div>
	</div>
</div>
<div class="message-box">
	<div class="nf-message" [innerHtml]="statusMessage"
		[ngClass]="{hasSubArray: 'notification.childNotifications > 0'}"></div>
	<!-- <div class="nf-message">{{notificationData.message}}</div> -->
	<div class="nf-counter" *ngIf="notification.childNotifications > 0" (click)="loadSubArray()">
		<button mat-button *ngIf="!shownNfs">
			Show {{notification.childNotifications}} more
		</button>
		<button mat-button *ngIf="shownNfs">
			Hide
		</button>
	</div>

	<div class="nf-subarray-block" *ngIf="subNfsArray && subNfsArray.length > 0">
		<div class="nf-subarray" *ngFor="let subNfs of subNfsArray">
			<!-- {{subNfs.message}} -->
			<app-sub-history-notification [notification]="subNfs">

			</app-sub-history-notification>
		</div>
	</div>

	<div class="nf-time">{{timeToShow}}</div>
</div>